import { Button, Dropdown, Field, Grid, Input, Textarea, type MenuItem } from "@/ui";
import type { ItemDraft } from "./routeConditionDraft";

// 独立路由规则的匹配条件（docs/10第10节）：MCC/MNC 与 Sender，没有时间条件（D132）。
// 匹配条件是网格，每个控件带标签；Sender 列表从"添加条件"菜单加入，移除按钮在该条件右侧。

interface CellProps { item: ItemDraft; n: number; onChange: (patch: Partial<ItemDraft>) => void }

// 匹配条件的输入框定宽：MCC、MNC 最多三位；第三列放移除按钮
const inputWidth = "130px";
const removeWidth = "calc(var(--space-10) + var(--space-2))";
const condColumns = `${inputWidth} ${inputWidth} ${removeWidth}`;
const wide2 = { gridColumn: "1 / 3" };

/** 匹配条件：MCC、MNC 直接编辑；Sender 列表从"添加条件"菜单加入，右侧可移除。空的表示不限。 */
export function ItemConditions({ item, n, onChange }: CellProps) {
  const id = `ri${n}`;
  const extra: MenuItem[] = [
    ...(item.senders_on ? [] : [{ key: "senders", label: "Sender 列表", hint: "精确匹配", onSelect: () => onChange({ senders_on: true }) }]),
  ];
  return (
    <Grid>
      <Grid columns={condColumns}>
        <Field label="MCC" htmlFor={`${id}-mcc`}><Input id={`${id}-mcc`} size="sm" mono placeholder="不限" aria-label={`第 ${n} 条 MCC`} value={item.mcc} onChange={(e) => onChange({ mcc: e.target.value.trim() })} /></Field>
        <Field label="MNC" htmlFor={`${id}-mnc`}><Input id={`${id}-mnc`} size="sm" mono placeholder="不限" aria-label={`第 ${n} 条 MNC`} value={item.mnc} onChange={(e) => onChange({ mnc: e.target.value.trim() })} /></Field>
        <div />
        {item.senders_on && <>
          <div style={wide2}><Field label="Sender 列表" htmlFor={`${id}-snd`} hint="每行一个，精确匹配"><Textarea id={`${id}-snd`} rows={2} aria-label={`第 ${n} 条 Sender`} value={item.senders} onChange={(e) => onChange({ senders: e.target.value })} /></Field></div>
          <Remove label={`移除第 ${n} 条 Sender 列表`} onClick={() => onChange({ senders_on: false, senders: "" })} />
        </>}
      </Grid>
      {extra.length > 0 && <div><Dropdown size="sm" variant="ghost" label="添加条件" items={extra} /></div>}
    </Grid>
  );
}

/** 条件右侧的移除按钮（列宽固定，各行输入框才一样宽），往下错开一个字段标签的高度，和输入框对齐。 */
function Remove({ label, onClick }: { label: string; onClick: () => void }) {
  return <div style={{ paddingTop: "var(--space-5)" }}><Button size="sm" variant="ghost" aria-label={label} onClick={onClick}>移除</Button></div>;
}
